import React, { CSSProperties, FC } from 'react'
import type { WidgetBadgeProps } from './widget-badge.d'
import styles from './widget-badge.module.scss'

export const WidgetBadge: FC<WidgetBadgeProps> = ({
  children,
  textColor = '#2F3A44',
  borderColor = '#EBB428',
  backgroundColor = '#FEF3DB',
}) => {
  const customClass: CSSProperties = {
    background: backgroundColor,
    color: textColor,
    border: `1px solid ${borderColor}`,
  }

  return (
    <div className={styles['root']} style={customClass}>
      {children}
    </div>
  )
}
